import React, { useState } from "react";
import NavBar from "../common/navBar/navBar";
import WithSideBar from "./withSidebar.jsx";
function UserLayoutPage({ children }) {
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);
  const [isFullWidth, setIsFullWidth] = useState(true);
  const [postTitle, setPostTitle] = useState(null);
  const toggleWidth = () => {
    setIsFullWidth((prevState) => !prevState);
  };
  const toggleSidebar = () => {
    setIsSidebarExpanded((prevState) => !prevState);
  };
  const handleClick = () => {
    toggleSidebar();
    toggleWidth();
  };
  const handleInputTitle = async (event) => {
    setPostTitle(event.target.value);
  };
  return (
    <>
      <NavBar handleClick={handleClick} handleInputTitle={handleInputTitle} />
      <WithSideBar stateWidth={{ isFullWidth, isSidebarExpanded }}>
        {/* {children} */}
        {React.Children.map(children, (child) =>
          React.cloneElement(child, { postTitle }),
        )}
      </WithSideBar>
    </>
  );
}
export default UserLayoutPage;
